import { PageHeader } from "@/components/page-header";
import { CsvImporter } from "@/components/csv-importer";

type Row = {
  name?: string; legalName?: string; type?: string; entity?: string;
  industry?: string; size?: string; employeeCount?: string; annualRevenue?: string;
  website?: string; linkedinUrl?: string; phone?: string; rating?: string;
  geography?: string; solutions?: string; cbcOfferings?: string; accountDegree?: string;
  description?: string;
  billingStreet?: string; billingCity?: string; billingState?: string; billingCode?: string; billingCountry?: string;
  shippingStreet?: string; shippingCity?: string; shippingState?: string; shippingCode?: string; shippingCountry?: string;
};

const FIELD_MAP: Record<string, keyof Row> = {
  // Identity
  "account name": "name", "name": "name",
  "legal name": "legalName",
  "account type": "type", "type": "type",
  "entity": "entity",
  // Profile
  "industry": "industry", "account industry": "industry",
  "size": "size", "employees": "employeeCount", "employee count": "employeeCount",
  "annual revenue": "annualRevenue", "revenue": "annualRevenue",
  // Web / contact
  "website": "website",
  "linkedin": "linkedinUrl", "linkedin url": "linkedinUrl",
  "phone": "phone",
  // Zoho-specific
  "rating": "rating",
  "geography": "geography",
  "solutions": "solutions",
  "cbc offerings": "cbcOfferings",
  "account degree": "accountDegree",
  "description": "description",
  // Billing
  "billing street": "billingStreet",
  "billing city":   "billingCity",
  "billing state":  "billingState",
  "billing code":   "billingCode", "billing zip": "billingCode", "billing postcode": "billingCode",
  "billing country": "billingCountry",
  // Shipping
  "shipping street": "shippingStreet",
  "shipping city":   "shippingCity",
  "shipping state":  "shippingState",
  "shipping code":   "shippingCode", "shipping zip": "shippingCode",
  "shipping country": "shippingCountry",
};

export default function AccountImportPage() {
  return (
    <>
      <PageHeader
        title="Import Accounts"
        description="Upload a Zoho-style Accounts CSV. Dedupes by domain."
      />
      <CsvImporter<Row>
        module="Accounts"
        endpoint="/accounts/bulk-import"
        backTo="/accounts"
        listQueryKey={["/accounts"]}
        fieldMap={FIELD_MAP}
        requiredField="name"
        description="Zoho export headers are auto-mapped: Account Name, Account Type, Industry, Annual Revenue, Phone, Website, Rating, Billing/Shipping address, etc. Max 1000 rows."
        previewColumns={[
          { field: "name",     label: "Name" },
          { field: "industry", label: "Industry" },
          { field: "website",  label: "Website" },
          { field: "phone",    label: "Phone" },
          { field: "annualRevenue", label: "Revenue" },
        ]}
      />
    </>
  );
}
